export default {
    data() {
        return {
            success: {
                user: false,
                receipt: false,
                amount: false,
                countryCode: false
            },
            error: {
                user: "",
                receipt: "",
                amount: "",
                countryCode: ""
            },
            errorMessages: {
                userRequired: {
                    el: "Ο χρήστης είναι υποχρεωτικός",
                    en: "User is required",
                    it: "L'utente è obbligatorio"
                },
                receiptRequired: {
                    el: "Ο αριθμός απόδειξης είναι υποχρεωτικός",
                    en: "Receipt Number is required",
                    it: "Il numero della ricevuta è obbligatorio"
                },
                amountRequired: {
                    el: "Το ποσό είναι υποχρεωτικό",
                    en: "Amount is required",
                    it: "L'importo è obbligatorio"
                },
                amountMin: {
                    el: "Το ποσό πρέπει να είναι τουλάχιστον 0.1",
                    en: "Amount must be minimum 0.1",
                    it: "L'importo deve essere almeno 0.1"
                },
                countryCodeRequired: {
                    el: "Απαιτείται κωδικός χώρας",
                    en: "Country code is required",
                    it: "Il codice paese è richiesto"
                },
            }
        };
    },

    computed: {
        valid() {
            if (this.showProducts) {
                let transactionProductsValid = true;
                this.transaction.products.forEach(p => {
                    if (p.reward_type_id === 4) {
                        if (p.retail_price < 0.1)
                            transactionProductsValid = false;
                    } else {
                        if (p.quantity < 1) transactionProductsValid = false;
                    }
                });

                if (this.showReceipt) {
                    return (
                        this.success.user &&
                        this.success.countryCode &&
                        this.success.receipt &&
                        this.productsSuccess &&
                        transactionProductsValid
                    );
                } else {
                    return (
                        this.success.user &&
                        this.success.countryCode &&
                        this.productsSuccess &&
                        transactionProductsValid
                    );
                }
            } else {
                if (this.showReceipt) {
                    return (
                        this.success.user &&
                        this.success.countryCode &&
                        this.success.receipt &&
                        this.success.amount
                    );
                } else {
                    return this.success.user && this.success.countryCode && this.success.amount;
                }
            }
        }
    },

    methods: {
        validateUser() {
            if (!this.transaction.user) {
                this.error.user = this.errorMessages.userRequired[this.lang];
            } else {
                this.error.user = "";
            }
            this.validateCountryCode()
        },
        validateCountryCode() {
            this.success.countryCode = !!this.transaction.country_id;
            if (!this.transaction.country_id) {
                this.error.countryCode = this.errorMessages.countryCodeRequired[
                    this.lang
                ];
            } else  {
                this.error.countryCode = "";
            }
        },

        async validateReceiptInput() {
            if (!this.transaction.receipt_identifier) {
                this.success.receipt = false
                this.error.receipt = this.errorMessages.receiptRequired[
                    this.lang
                ];
            } else {
                this.error.receipt = "";
                this.success.receipt = await this.checkReceiptData({receipt_identifier: this.transaction.receipt_identifier})
            }
        },

        validateAmount() {
            if (!this.transaction.amount) {
                this.error.amount = this.errorMessages.amountRequired[
                    this.lang
                ];
            } else if (Number(this.transaction.amount) < 0.1) {
                this.error.amount = this.errorMessages.amountMin[this.lang];
            } else {
                this.error.amount = "";
            }
        }
    },

    watch: {
        ["transaction.user"](val) {
            this.success.user = !!val;
        },

        ["transaction.ccountry_id"](val) {
            this.success.countryCode = !!val;
        },

        ["transaction.receipt_number"](val) {
            if(this.transaction.receipt_identifier){
                this.transaction.receipt_identifier=undefined
            }
            this.success.receipt = !!val;
        },

        ["transaction.receipt_identifier"](val) {
            if(!this.transaction.receipt_number){
                this.success.receipt = !!val;
            }
        },

        ["transaction.amount"](val) {
            this.success.amount = !isNaN(Number(val))&&val >= 0.1;
        }
    }
};
